import type {
  ILeasingRequestInfo,
  ILeasingRequestResponse,
  IRequestInfo,
  IResponse
} from '../types/requests.types';

const mapLeasingResponseFromApi = (
  response: ILeasingRequestResponse,
  requestId: string
): IResponse => ({
  uuid: response?.uuid || '',
  initial_payment: String(response?.initial_payment ?? 0),
  loan_period: response?.leasing_term ?? 0,
  loan_amount: String(response?.approved_amount ?? 0),
  vehicle_cost: String(response?.vehicle_cost ?? 0),
  monthly_payment:
    response?.monthly_payment === null ||
    response?.monthly_payment === undefined
      ? null
      : String(response?.monthly_payment),
  rate: response?.rate ?? null,
  response_date: response?.response_date ?? null,
  payment_date: response?.payment_date ?? null,
  create_date: response?.create_date || '',
  loan_agreement: response?.loan_agreement ?? null,
  status_uuid: response?.status_uuid || '',
  ext_uuid: response?.execution_id || null,
  bank_description: response?.comment ?? null,
  request_uuid: response?.leasing_uuid || requestId,
  bank_uuid: response?.leasing_company_uuid || '',
  is_offered: response?.is_offered ?? null,
  offered_uuid: response?.offered_uuid ?? null,
  insurance_amount:
    response?.insurance_amount === null ||
    response?.insurance_amount === undefined
      ? null
      : String(response?.insurance_amount),
  response_approved_body: null,
  response_sended_body: null,
  execution_id: response?.execution_id ?? null,
  response_primary_body: null,
  approved_date: response?.approved_date ?? null,
  funded_date: response?.funded_date ?? null,
  with_pledge: null,
  scenario_name: null,
  bank_user_uuid: response?.leasing_user_uuid ?? null,
  user: response?.user || undefined,
  status: {
    uuid: response?.status?.uuid || '',
    name: response?.status?.name || '',
    code: response?.status?.code || ''
  },
  bank: {
    code: response?.Leasing_Company?.code || '',
    fullname: response?.Leasing_Company?.name || '',
    name: response?.Leasing_Company?.name || '',
    uuid: response?.Leasing_Company?.uuid || '',
    icon: response?.Leasing_Company?.icon || '',
    is_active: !!response?.Leasing_Company?.is_active
  },
  Responses_Alternatives: []
});

export const leasingRequestMapperFromApi = (
  payload: ILeasingRequestInfo
): IRequestInfo => {
  const responses = Array.isArray(payload?.responses) ? payload.responses : [];

  return {
    uuid: payload?.uuid || '',
    user_uuid: payload?.user_uuid ?? null,
    code: payload?.code ?? null,
    is_proof_income: !!payload?.is_proof_income,
    is_promo: !!payload?.is_promo,
    create_date: payload?.create_date || '',
    vehicle_cost: String(payload?.total_amount ?? payload?.request_amount ?? 0),
    request_amount: String(payload?.request_amount ?? 0),
    loan_period_code: payload?.loan_period_code ?? payload?.period ?? 0,
    payment_date: payload?.payment_date ?? null,
    init_fee: payload?.initial_payment ?? 0,
    engine_type_uuid: payload?.engine_type_uuid ?? '',
    repayment_type_uuid: payload?.repayment_type_uuid ?? '',
    dealer_uuid: payload?.dealer_uuid || '',
    chosen_dealer_uuid: payload?.chosen_dealer_uuid || '',
    vin_code: payload?.vin_code ?? null,
    color_uuid: payload?.final_color_uuid ?? '',
    auto_type_uuid: payload?.auto_type_uuid ?? '',
    model_uuid: payload?.equipment?.model?.uuid || '',
    equipment_uuid: payload?.equipment_uuid || payload?.equipment?.uuid || '',
    final_color_uuid: payload?.final_color_uuid ?? null,
    final_color_text: null,
    client_uuid: payload?.client_uuid || '',
    status_uuid: payload?.status_uuid || '',
    vehicle_plate_number: null,
    vehicle_first_payment_date: null,
    vehicle_registration_company_uuid: null,
    vehicle_body_number: null,
    vehicle_engine_capacity: 0,
    vehicle_registration_date: null,
    vehicle_registration_number: null,
    otp: payload?.otp ?? '',
    otp_create_date: payload?.otp_create_date ?? '',
    otp_attempts_count: payload?.otp_attempts_count ?? 0,
    car_year: payload?.car_year ?? '',
    biometric_session_uuid: payload?.biometric_session_uuid ?? null,
    request_types_uuid: payload?.request_type_uuid ?? '',
    status: {
      uuid: payload?.status?.uuid || '',
      name: payload?.status?.name || '',
      code: payload?.status?.code || ''
    },
    Files: Array.isArray(payload?.Files) ? payload.Files : [],
    model: {
      uuid: payload?.equipment?.model?.uuid || '',
      name: payload?.equipment?.model?.name || '',
      img_src: payload?.equipment?.model?.img_src || '',
      brand: {
        name: payload?.equipment?.model?.brand?.name || '',
        img_src: payload?.equipment?.model?.brand?.img_src || ''
      }
    },
    equipment: {
      uuid: payload?.equipment?.uuid || '',
      name: payload?.equipment?.name || ''
    },
    dealer: {
      uuid: payload?.dealer?.uuid || '',
      name: payload?.dealer?.name || '',
      physical_address: payload?.dealer?.physical_address ?? null,
      city: {
        name: payload?.dealer?.city?.name || ''
      }
    },
    Responses: responses.map((response) =>
      mapLeasingResponseFromApi(response, payload?.uuid || '')
    ),
    leasing_type: payload?.temp_leasing_type ?? null
  };
};
